import { useState } from 'react';
import { parseLinkedInZip } from '../lib/parseLinkedInZip';

export function useLinkedInImport() {
  const [importStep, setImportStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [importedProfile, setImportedProfile] = useState(null);
  const [importedPositions, setImportedPositions] = useState([]);
  const [importedConnections, setImportedConnections] = useState([]);

  async function handleFileUpload(file) {
    setError('');
    setLoading(true);

    try {
      if (!file.name.endsWith('.zip')) {
        setError('Please upload a LinkedIn data export ZIP file.');
        setLoading(false);
        return;
      }

      const { profile, positions, connections } = await parseLinkedInZip(file);

      if (connections.length === 0 && !profile) {
        setError('No valid data found in the ZIP file. Make sure it\'s a LinkedIn data export.');
        setLoading(false);
        return;
      }

      setImportedProfile(profile);
      setImportedPositions(positions);
      setImportedConnections(connections);
      setImportStep(3);
    } catch (err) {
      setError(`Error parsing file: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }

  function reset() {
    setImportStep(1);
    setLoading(false);
    setError('');
    setImportedProfile(null);
    setImportedPositions([]);
    setImportedConnections([]);
  }

  return {
    importStep,
    setImportStep,
    loading,
    error,
    importedProfile,
    importedPositions,
    importedConnections,
    handleFileUpload,
    reset,
  };
}
